const styles = {
  overlayCover: {
    minWidth: '100%',
    height: '100%'
  },
  container: {
    backgroundColor: 'white',
    textAlign: 'left'
  }
};

export default styles;
